export default function TabBar({ tabs, activeTab, onTabChange }) {
  return (
    <div className="flex items-center gap-1 border-b border-[#1e2235]">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              px-4 py-3 font-medium text-sm transition-colors border-b-2
              ${
                isActive
                  ? 'text-blue-400 border-b-blue-500'
                  : 'text-gray-400 border-b-transparent hover:text-gray-300'
              }
            `}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
